module.exports = __webpack_public_path__ + "static/media/flowers.78eba2c7.gif";